import { WarningAmberOutlined } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';

import * as S from './styles';

function Error() {
  return (
    <S.Container>
      <WarningAmberOutlined />
      <S.ErrorMessage variant="body2">
        <FormattedMessage id="CAREMATRIXCPTC.ERRORMESSAGE.GENERICERROR" />
      </S.ErrorMessage>
    </S.Container>
  );
}

export default Error;
